import { motion, MotionValue, useSpring, useTransform } from "framer-motion";
import { useEffect } from "react";

import { SmallTitle } from "@/components/text/SmallTitle";

export function NumericProgress({ progress }: { progress: number }) {
  const spring: MotionValue<number> = useSpring(progress, {
    duration: 1000,
    bounce: 0,
  });

  const display: MotionValue<string> = useTransform(spring, (current) =>
    Math.round(current).toLocaleString()
  );

  useEffect(() => {
    spring.set(progress);
  }, [spring, progress]);

  return (
    <motion.div
      className="ml-3 w-9 rounded-lg bg-gray-900/10 p-1 text-center"
      key={progress}
      initial={{ scale: 0.8, opacity: 0.7 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{
        duration: 0.3,
        ease: "easeOut",
      }}
    >
      <SmallTitle elementType="span">
        <motion.span>{display}</motion.span>%
      </SmallTitle>
    </motion.div>
  );
}
